const columns = {
  type: { id: "type", name: "Type", sortable: false, deselectable: false },
  summary: { id: "summary", name: "Summary", sortable: false, deselectable: true },
  user: { id: "user", name: "User", sortable: true, deselectable: false },
  created_at: { id: "created_at", name: "Created", sortable: true, deselectable: false },
  details: { id: "details", name: "Details", sortable: false, deselectable: true, classes: "hidden lg:table-cell" },
  actions: { id: "actions", name: "", sortable: false, deselectable: false },
}

const defaultColumns = [
  "type",
  "summary",
  "user",
  "created_at",
  "details",
  "actions",
]

const downloadOptions = [
  { key: "xls", name: "Download All XLS" }
]

const filterGroups = {
  "bookings": {
    "title": "Bookings", 
    "types": ["BOOKING", "BOOKING_CANCELLATION", "BOOKING_AUTO_CANCELLATION"], 
    "ids": [1, 2, 3]
  },

  "events": {
    "title": "Events", 
    "types": ["EVENT_CREATED", "EVENT_UPDATED"], 
    "ids": [17, 18]
  },

  "invitations": {
    "title": "Invitations", 
    "types": ["INVITE_MANUALLY_CREATED", "GUARDIAN_REMOVED_FROM_EVENT"], 
    "ids": [12, 16]
  },

  "lessons_groups": {
    "title": "Lessons & Groups", 
    "types": ["LESSON_ADDED", "LESSON_REMOVED", "GROUP_ADDED", "GROUP_REMOVED", "GROUP_UPDATED", "GROUP_LESSON_STUDENT_ADDED", "GROUP_LESSON_STUDENT_REMOVED", "GROUP_LESSONS_REASSIGNED", "GROUP_LESSONS_DUPLICATED"], 
    "ids": [4, 5, 6, 7, 8, 9, 10, 11, 22]
  },

  "notifications": {
    "title": "Notifications", 
    "types": ["NOTIFICATION_SENT"], 
    "ids": [21]
  },

  "sessions": {
    "title": "Sessions", 
    "types": ["SESSION_ADDED", "SESSION_UPDATED", "SESSION_DELETED"], 
    "ids": [15, 19, 20]
  },

  "slots": {
    "title": "Slots", 
    "types": ["SLOT_DISABLED", "SLOT_AVAILABLE"], 
    "ids": [13, 14]
  },
}

const typeStyles = {
  BOOKING: "bg-blue-800",
  BOOKING_CANCELLATION: "bg-blue-600",
  BOOKING_AUTO_CANCELLATION: "bg-blue-400",
  LESSON_ADDED: "bg-green-600",
  LESSON_REMOVED: "bg-pink-400",
  GROUP_REMOVED: "bg-pink-400",
  GROUP_LESSON_STUDENT_ADDED: "bg-green-400",
  GROUP_LESSON_STUDENT_REMOVED: "bg-pink-400",
  GROUP_LESSONS_REASSIGNED: "bg-lime-500",
  GROUP_LESSONS_DUPLICATED: "bg-purple-500",
  GROUP_ADDED: "bg-green-600",
  INVITE_MANUALLY_CREATED: "bg-green-600",
  SLOT_DISABLED: "bg-slate-600",
  SLOT_AVAILABLE: "bg-green-700",
  SESSION_DELETED: "bg-pink-400",
  OTHER: "bg-gray-400",
  GUARDIAN_REMOVED_FROM_EVENT: "bg-pink-400",
  EVENT_CREATED: "bg-green-600",
  EVENT_UPDATED: "bg-green-400",
  SESSION_ADDED: "bg-green-600",
  SESSION_UPDATED: "bg-green-400",
  NOTIFICATION_SENT: "bg-blue-500",
  GROUP_UPDATED: "bg-green-400",
  EVENT_SCHEDULED_ACTION_CREATED: "bg-green-600",
  EVENT_SCHEDULED_ACTION_UPDATED: "bg-green-400",
  EVENT_SCHEDULED_ACTION_DELETED: "bg-pink-400",

}

export { columns, defaultColumns, downloadOptions, filterGroups, typeStyles }